<template>
  <div class="create-quote">
    <b-container>
      <b-row>
        <h1>New Quotation</h1>
      </b-row>
      <b-row>
        <b-button variant="primary" @click="back">Back</b-button>
      </b-row>
      <b-form @submit.prevent="create_quote">
        <!-- CUSTOMER INFORMATION -->
        <div id="customer-information">
          <b-row align-v="center">
            <b-col cols="3">
              <h3>Customer Info.</h3>
            </b-col>
            <b-col>
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-name"
                label="Customer Name*"
                label-for="customer-name-input"
              >
                <b-form-input
                  id="customer-name-input"
                  v-model="customer_name"
                  required
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="customer-phone"
                label="Customer Phone*"
                label-for="customer-phone-input"
              >
                <b-form-input
                  id="customer-phone-input"
                  v-model="customer_phone"
                  required
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-email"
                label="Customer Email"
                label-for="customer-email-input"
              >
                <b-form-input
                  id="customer-email-input"
                  v-model="customer_email"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <label for="form_details.cemetery">Cemetery:</label>
              <b-form-select
                :disabled="isProcessing ? true : false"
                v-model="customer_cemetery"
                :options="cemeteryNames"
              ></b-form-select>
            </b-col>
            <!-- <b-col>
              <b-form-group
                id="customer-cemetery"
                label="Cemetery"
                label-for="customer-cemetery-input">
                <b-form-input id="customer-cemetery-input" 
                  v-model="customer_cemetery"
                  trim></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-section"
                label="Section"
                label-for="customer-section-input"
              >
                <b-form-input
                  id="customer-section-input"
                  v-model="customer_section"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <label for="funeral_provider">Funeral Provider:</label>
              <b-form-select
                id="funeral_provider"
                :disabled="isProcessing ? true : false"
                v-model="customer_funeral_provider"
                :options="funeral_provider_names"
              ></b-form-select>
            </b-col>
            <!-- <b-col>
              <b-form-group
                id="customer-funeral-provider"
                label="Funeral Provider*"
                label-for="customer-funeral-provider-input">
                <b-form-input id="customer-funeral-provider-input" 
                  v-model="customer_funeral_provider"
                  required
                  trim></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-row"
                label="Row"
                label-for="customer-row-input"
              >
                <b-form-input
                  id="customer-row-input"
                  v-model="customer_row"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="customer-grave-number"
                label="Grave No."
                label-for="customer-grave-number-input"
              >
                <b-form-input
                  id="customer-grave-number-input"
                  v-model="customer_grave_number"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-how-find"
                label="How did you find us?*"
                label-for="customer-how-find-input"
              >
                <b-form-select
                  :disabled="isProcessing ? true : false"
                  v-model="customer_how_find"
                  :options="lead_source_names"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-comment"
                label="Comment"
                label-for="customer-comment"
              >
                <b-form-input
                  id="customer-comment"
                  v-model="customer_comment"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <!-- MONUMENT INFORMATION -->
        <b-row
          align-v="center"
          v-b-toggle.accordion-monument
          v-if="new_quote_type == 'monument'"
        >
          <b-col cols="3">
            <h3>Monument Info.</h3>
          </b-col>
          <b-col cols="8">
            <hr />
          </b-col>
          <b-col>
            <b-row>
              <b-icon
                icon="chevron-down"
                scale="1"
                variant="secondary"
              ></b-icon>
            </b-row>
          </b-col>
        </b-row>
        <b-collapse
          visible
          id="accordion-monument"
          role="tabpanel"
          class="mx-3"
          v-if="new_quote_type == 'monument'"
        >
          <b-row>
            <b-col>
              <b-form-group
                id="monument-style"
                label="Monument Style"
                label-for="monument-style-select"
              >
                <b-form-select
                  id="monument-style-select"
                  v-model="monument_style"
                  required
                  :options="monument_style_names"
                ></b-form-select>
              </b-form-group>
              <!-- <b-form-group
                id="monument-style"
                label="Monument Type"
                label-for="monument-style-select">
                <b-form-select id="monument-style-select"
                  v-model="monument_style" 
                  required
                  :options="monument_style_names"></b-form-select>
              </b-form-group> -->
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group
                id="monument-type"
                label="Monument Type"
                label-for="monument-type-input"
              >
                <b-form-input
                  id="monument-type-input"
                  v-model="monument_type"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-v="center">
            <b-col cols="3">
              <h3>Material Info.</h3>
            </b-col>
            <b-col>
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="primary" @click="add_material"
                >Add a material</b-button
              >
            </b-col>
          </b-row>
          <b-row
            v-for="(material, index) in materials"
            :key="'material' + index"
            align-v="center"
          >
            <b-col cols="4">
              <b-form-group
                id="monument-material"
                label="Monument Material"
                label-for="monument-material-select"
              >
                <b-form-select
                  :id="'monument-material-list-' + index"
                  v-model="materials[index].name"
                  :options="material_name_options"
                  v-on:change="materials_changed(materials[index].name)"
                  required
                ></b-form-select>

                <!-- <b-form-input :list="'monument-material-list-'+ index"
                    v-model="materials[index].name"
                    v-on:change="materials_changed">
                  </b-form-input>

                  <datalist :id="'monument-material-list-' + index">
                    <option v-for="(name, i) in material_name_options" :key="'material_name_option' + i">{{ name }}</option>
                  </datalist> -->

                <!-- <b-form-select id="monument-material-select"
                    v-model="materials[index].name"
                    v-on:change="materials_changed"
                    :options="material_name_options"></b-form-select>  -->
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group
                id="monument-size"
                label="Monument Size"
                label-for="monument-size-select"
              >
                <b-form-select
                  id="monument-size-select"
                  v-model="materials[index].size"
                  :options="materials[index].sizes"
                  v-on:change="material_size_change(index)"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                id="monument-usage"
                label="Usage"
                label-for="monument-usage-input"
              >
                <b-form-input
                  id="monument-size-input"
                  type="number"
                  v-model="materials[index].usage"
                  step=".01"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_material(index)"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
        </b-collapse>
        <!-- INSTALLATION INFORMATION -->
        <div id="installation-information" v-if="new_quote_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-installation>
            <b-col cols="3">
              <h3>Installation</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-installation" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary" @click="add_installation">
                  Add an installation
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-for="(installation, index) in installations"
              :key="'installation' + index"
              align-v="center"
            >
              <b-col cols="11">
                <b-form-group
                  id="installation-name"
                  label="Installation Name"
                  label-for="installation-name-select"
                >
                  <b-form-select
                    v-model="installations[index].name"
                    :options="installation_name_options"
                    v-on:change="
                      installations_change(installations[index].name)
                    "
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon
                  class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_installation(index)"
                ></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- INSCRIPT INFORMATION -->
        <div id="inscript-information">
          <b-row align-v="center" v-b-toggle.accordion-inscript>
            <b-col cols="3">
              <h3>Inscription</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col cols="1">
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
            <b-col>
              <p>* Outside the Metro Cemetery requires a travel fee $250+GST</p>
              <p>* Elaine or Geelong cemetery requires $350+GST</p>
              <p>* Any surcharge/travel fee need to be added in extra fee</p>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-inscript" role="tabpanel">
            <b-row>
              <b-col>
                <b-dropdown variant="primary" text="Add an inscription">
                  <div>
                    <b-dropdown-item @click="add_inscription('arabic')"
                      >Arabic<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('decoration')"
                      >Decoration<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('english')"
                      >English<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('chinese')"
                      >Chinese<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('Additional')"
                      >Additional Inscription<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('Crypt Shutters')"
                      >Crypt Shutters<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                  </div>
                </b-dropdown>
              </b-col>
            </b-row>
            <b-row
              v-for="(inscription, index) in inscriptions"
              :key="'inscription' + index"
              align-v="center"
            >
              <b-col cols="5">
                <b-form-group
                  v-if="inscriptions[index].type == 'arabic'"
                  id="inscription-name"
                  :label="'Inscription Name' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="inscription_arabic_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="inscriptions[index].type == 'decoration'"
                  id="inscription-name"
                  :label="'Inscription Name - ' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="inscription_decoration_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="inscriptions[index].type == 'english'"
                  id="inscription-name"
                  :label="'Inscription Name - ' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="inscription_english_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="inscriptions[index].type == 'chinese'"
                  id="inscription-name"
                  :label="'Inscription Name - ' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="inscription_chinese_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="inscriptions[index].type == 'Additional'"
                  id="inscription-name"
                  :label="'Inscription Name - ' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="additional_inscription_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  v-if="inscriptions[index].type == 'Crypt Shutters'"
                  id="inscription-name"
                  :label="'Inscription Name - ' + inscriptions[index].type"
                  label-for="inscription-name-select"
                >
                  <b-form-select
                    v-model="inscriptions[index].name"
                    :options="crypt_shutters_name_options"
                    v-on:change="inscriptions_change(inscriptions[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group
                  id="inscription-number"
                  label="Number"
                  label-for="inscription-number-input"
                >
                  <b-form-input
                    id="inscription-number-input"
                    v-model="inscriptions[index].number"
                    type="number"
                    min="0"
                    required
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-icon
                  class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_inscription(index)"
                ></b-icon>
              </b-col>
              <b-col>
                <p
                  v-if="
                    inscriptions[index].name ==
                      '[Per Letter]Under 40 letters(& included 40 letters)'
                  "
                >
                  * $200 surcharge included for Under 40 letters(& included 40
                  letters)
                </p>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- ACCESSORY INFORMATION -->
        <div id="accessory-information">
          <b-row align-v="center" v-b-toggle.accordion-accessory>
            <b-col cols="3">
              <h3>Accessory</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-accessory" role="tabpanel">
            <b-row>
              <b-col>
                <b-dropdown variant="primary" text="Add an accessory">
                  <b-dropdown-item @click="add_door()"
                    >Door
                    <b-icon icon="plus" scale="1.5" variant="primary"></b-icon
                  ></b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add_photo()"
                    >Photo
                    <b-icon icon="plus" scale="1.5" variant="primary"></b-icon
                  ></b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add_others()"
                    >Others
                    <b-icon icon="plus" scale="1.5" variant="primary"></b-icon
                  ></b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div>
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Doors</h3>
                </b-col>
                <b-col>
                  <hr />
                </b-col>
              </b-row>
              <b-row
                class="ml-2"
                v-for="(door, index) in accessory_doors"
                :key="'door' + index"
                align-v="center"
              >
                <b-col cols="4">
                  <b-form-group
                    id="accessory-door-name"
                    label="Door Name"
                    label-for="accessory-door-name-select"
                  >
                    <b-form-select
                      v-model="accessory_doors[index].name"
                      :options="accessory_door_name_options"
                      v-on:change="
                        accessory_doors_changed(accessory_doors[index].name)
                      "
                      required
                    ></b-form-select>
                    <!-- <b-form-input :list="'accessory-door-name-list-'+ index"
                      v-model="accessory_doors[index].name"
                      v-on:change="accessory_doors_changed">
                    </b-form-input>

                    <b-form-input id="accessory-door-quantity-input"
                      v-model="accessory_door_quantity"
                      required
                      type="number"></b-form-input>

                    <datalist :id="'accessory-door-name-list-' + index">
                      <option v-for="(name, i) in accessory_door_name_options" :key="'accessory_door_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-door-size"
                    label="Door Size"
                    label-for="accessory-door-select"
                  >
                    <b-form-select
                      id="accessory-door-select"
                      v-model="accessory_doors[index].size"
                      :options="accessory_doors[index].sizes"
                      v-on:change="accessory_doors_size_changed(index)"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-door-quantity"
                    label="Quantity"
                    label-for="accessory-door-quantity-input"
                  >
                    <b-form-input
                      id="accessory-door-quantity-input"
                      v-model="accessory_doors[index].quantity"
                      required
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon
                    class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_door(index)"
                  ></b-icon>
                </b-col>
              </b-row>
              <!-- PHOTOS -->
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Photos</h3>
                </b-col>
                <b-col>
                  <hr />
                </b-col>
              </b-row>
              <b-row
                class="ml-2"
                v-for="(photo, index) in accessory_photos"
                :key="'photo' + index"
                align-v="center"
              >
                <b-col cols="4">
                  <b-form-group
                    id="accessory-photo-name"
                    label="Photo Name"
                    label-for="accessory-photo-name-select"
                  >
                    <b-form-select
                      v-model="accessory_photos[index].name"
                      :options="accessory_photo_name_options"
                      v-on:change="
                        accessory_photos_changed(accessory_photos[index].name)
                      "
                      required
                    ></b-form-select>
                    <!-- <b-form-input :list="'accessory-photo-name-list-'+ index"
                      v-model="accessory_photos[index].name"
                      v-on:change="accessory_photos_changed">
                    </b-form-input>

                    <datalist :id="'accessory-photo-name-list-' + index">
                      <option v-for="(name, i) in accessory_photo_name_options" :key="'accessory_photo_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-photo-size"
                    label="Photo Size"
                    label-for="accessory-photo-select"
                  >
                    <b-form-select
                      id="accessory-photo-select"
                      v-model="accessory_photos[index].size"
                      :options="accessory_photos[index].sizes"
                      v-on:change="accessory_photos_size_changed(index)"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-photo-quantity"
                    label="Quantity"
                    label-for="accessory-photo-quantity-input"
                  >
                    <b-form-input
                      id="accessory-photo-quantity-input"
                      v-model="accessory_photos[index].quantity"
                      required
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon
                    class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_photo(index)"
                  ></b-icon>
                </b-col>
              </b-row>
              <!--Others -->
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Others</h3>
                </b-col>
                <b-col>
                  <hr />
                </b-col>
              </b-row>
              <b-row
                class="ml-2"
                v-for="(others, index) in accessory_others"
                :key="'others' + index"
                align-v="center"
              >
                <b-col cols="4">
                  <b-form-group
                    id="accessory-others-name"
                    label="Name"
                    label-for="accessory-others-name-select"
                  >
                    <b-form-select
                      v-model="accessory_others[index].name"
                      :options="accessory_others_name_options"
                      v-on:change="
                        accessory_others_changed(accessory_others[index].name)
                      "
                      required
                    ></b-form-select>
                    <!-- <b-form-input :list="'accessory-others-name-list-'+ index"
                      v-model="accessory_others[index].name"
                      v-on:change="accessory_others_changed">
                    </b-form-input>

                    <datalist :id="'accessory-others-name-list-' + index">
                      <option v-for="(name, i) in accessory_others_name_options" :key="'accessory_others_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-others-size"
                    label="Others Size"
                    label-for="accessory-others-select"
                  >
                    <b-form-select
                      id="accessory-others-select"
                      v-model="accessory_others[index].size"
                      :options="accessory_others[index].sizes"
                      v-on:change="accessory_others_size_changed(index)"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-others-quantity"
                    label="Quantity"
                    label-for="accessory-others-quantity-input"
                  >
                    <b-form-input
                      id="accessory-others-quantity-input"
                      v-model="accessory_others[index].quantity"
                      required
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon
                    class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_others(index)"
                  ></b-icon>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </div>
        <!-- PERMIT INFORMATION -->
        <div id="permit-information">
          <b-row align-v="center" v-b-toggle.accordion-permit>
            <b-col cols="3">
              <h3>Permit fee</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-permit" role="tabpanel">
            <b-row>
              <b-col>
                <b-form-group id="permit-fee">
                  <b-form-input
                    id="permit-fee-input"
                    v-model="permit_fee"
                    type="number"
                    min="0"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- FOUNDATION INFORMATION -->
        <div id="foundation-information" v-if="new_quote_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-foundation>
            <b-col cols="3">
              <h3>Foundation</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-foundation" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary" @click="add_foundation">
                  Add a foundation
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-for="(foundation, index) in foundations"
              :key="'foundation' + index"
              align-v="center"
            >
              <b-col cols="11">
                <b-form-group
                  id="foundation-name"
                  label="Foundation Name"
                  label-for="foundation-name-select"
                >
                  <b-form-select
                    v-model="foundations[index].name"
                    :options="foundation_name_options"
                    v-on:change="foundations_change(foundations[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon
                  class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_foundation(index)"
                ></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- Carving INFORMATION -->
        <div id="casting-information" v-if="new_quote_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-casting>
            <b-col cols="3">
              <h3>Carving</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-casting" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary" @click="add_casting">
                  Add a carving
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-for="(casting, index) in castings"
              :key="'casting' + index"
              align-v="center"
            >
              <b-col cols="11">
                <b-form-group
                  id="casting-name"
                  label="Carving Name"
                  label-for="casting-name-select"
                >
                  <b-form-select
                    v-model="castings[index].name"
                    :options="casting_name_options"
                    v-on:change="castings_change(castings[index].name)"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon
                  class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_casting(index)"
                ></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- EXTRA FEE INFORMATION -->
        <div id="extra-fee-information">
          <b-row align-v="center" v-b-toggle.accordion-information>
            <b-col cols="3">
              <h3>Extra Fee</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-information" role="tabpanel">
            <b-row>
              <b-col cols="2">
                <b-form-group id="extra-fee" label="Fee">
                  <b-form-input
                    id="permit-fee-input"
                    v-model="extra_fee"
                    type="number"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="10">
                <b-form-group
                  id="extra-fee-description"
                  label="Description"
                  label-for="extra-fee-description"
                >
                  <b-form-input
                    id="extra-fee-description"
                    v-model="extra_fee_description"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- DISOUNT INFORMATION -->
        <div id="discount-information" v-if="new_quote_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-discount>
            <b-col cols="3">
              <h3>Material Discount</h3>
            </b-col>
            <b-col cols="8">
              <hr />
            </b-col>
            <b-col>
              <b-row>
                <b-icon
                  icon="chevron-down"
                  scale="1"
                  variant="secondary"
                ></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-discount" role="tabpanel">
            <b-row align-v="center">
              <b-col cols="11">
                <b-form-group id="quote_discount">
                  <b-form-input
                    id="quote_discount-input"
                    v-model="quote_discount"
                    type="number"
                    min="0"
                    max="10"
                    trim
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="1">%</b-col>
            </b-row>
          </b-collapse>
        </div>
        <b-button type="submit" v-if="!quote_created" variant="primary" block
          >Create</b-button
        >
        <b-button
          v-if="created_successfully"
          variant="primary"
          block
          @click="export_quote"
          >Export</b-button
        >
        <br /><br /><br />
      </b-form>

      <b-modal
        size="lg"
        id="modal-create-quote"
        title="Creation confirmation"
        hide-footer
      >
        <p>This operation will create a quote.</p>
        <div>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Customer Name: </strong>{{ this.customer_name }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Customer Phone: </strong>{{ this.customer_phone }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Cemetery: </strong>{{ this.customer_cemetery }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Section: </strong>{{ this.customer_section }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Grave No: </strong
                      >{{ this.customer_grave_number }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Funeral Provider: </strong
                      >{{ this.customer_funeral_provider }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Comment: </strong>{{ this.customer_comment }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Style: </strong>{{ this.monument_style }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Sales: </strong>{{ this.created_by_name }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Created date: </strong>{{ this.create_date }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br />
              <div>
                <div v-if="this.materials.length > 0" class="monument">
                  <b-row>
                    <b-col>
                      <strong>Monument</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>Price</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(material, index) in this.materials"
                    :key="'material' + index"
                  >
                    <b-col>
                      {{ material.name
                      }}<span>
                        - {{ material.size }} - {{ material.usage }}</span
                      >
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ material.total_price }} 
                      <span v-if="quote_discount != '0'">
                        (discount applied)
                      </span>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.quote_discount > 0" class="discount">
                  <b-row>
                    <b-col>
                      <strong>Material Discount</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ this.quote_discount }}% off
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.permit_fee > 0" class="permit-fee">
                  <b-row>
                    <b-col>
                      <strong>Permit Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ this.permit_fee }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.inscriptions.length > 0" class="Inscription">
                  <b-row>
                    <b-col>
                      <strong>Inscription</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(inscription, index) in this.inscriptions"
                    :key="'inscription' + index"
                  >
                    <b-col>
                      {{ inscription.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      <span
                        v-if="
                          inscription.name ==
                            '[Per Letter]Under 40 letters(& included 40 letters)'
                        "
                      >
                        200 +
                      </span>
                      {{ inscription.price }} * {{ inscription.number }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.accessories.length > 0" class="Accessory">
                  <b-row>
                    <b-col>
                      <strong>Accessory</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(accessory, index) in this.accessories"
                    :key="'accessory' + index"
                  >
                    <b-col>
                      {{ accessory.name }} - {{ accessory.size }} *
                      {{ accessory.quantity }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ accessory.total_price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.castings.length > 0" class="Casting">
                  <b-row>
                    <b-col>
                      <strong>Carving</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(casting, index) in this.castings"
                    :key="'casting' + index"
                  >
                    <b-col>
                      {{ casting.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ casting.price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.installations.length > 0" class="Installation">
                  <b-row>
                    <b-col>
                      <strong>Installation</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(installation, index) in this.installations"
                    :key="'installation' + index"
                  >
                    <b-col>
                      {{ installation.name }}
                    </b-col>
                    <b-col v-if="installation.name != 'Remove Existing Monument - Major(Whole Monument)'" class="text-right" cols="2">
                      {{ installation.price }}
                    </b-col>
                    <b-col v-if="installation.name == 'Remove Existing Monument - Major(Whole Monument)'" class="text-right" cols="2">
                      New Install Price
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.foundations.length > 0" class="Foundation">
                  <b-row>
                    <b-col>
                      <strong>Foundation</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(foundation, index) in this.foundations"
                    :key="'foundation' + index"
                  >
                    <b-col>
                      {{ foundation.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ foundation.price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.extra_fee != 0" class="extra-fee">
                  <b-row>
                    <b-col>
                      <strong>Extra Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ this.extra_fee }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      {{ this.extra_fee_description }}
                    </b-col>
                  </b-row>
                </div>
                <br />
                <div class="total-price">
                  <b-row>
                    <b-col>
                      <strong>Total Price</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>{{ this.total_price }}</strong>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-create-quote')"
          >
            Cancel
          </b-button>
          <b-button variant="primary" @click="create_quote_task">
            Create
          </b-button>
        </div>
      </b-modal>

      <!-- DUPLICATE CUSTOMER ALERT -->
      <b-modal
        size="lg"
        id="modal-same-customer-alert"
        title="Existing records of this customer detected!"
        hide-footer
      >
        <div v-for="quote in quotes_with_same_customer_name" :key="quote.id">
          <b-row>
            <b-col cols="10">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Customer Name: </strong>{{ quote.customer_name }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Customer Phone: </strong
                      >{{ quote.customer_phone }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Cemetery: </strong>{{ quote.customer_cemetery }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Section: </strong>{{ quote.customer_section }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Grave No: </strong
                      >{{ quote.customer_grave_number }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Funeral Provider: </strong
                      >{{ quote.customer_funeral_provider }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Comment: </strong>{{ quote.customer_comment }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Style: </strong>{{ quote.monument_style }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Sales: </strong>{{ quote.created_by_name }}
                    </b-col>
                    <b-col cols="12">
                      <strong>Created date: </strong>{{ quote.create_date }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br />
              <div>
                <div v-if="quote.materials.length > 0" class="monument">
                  <b-row>
                    <b-col>
                      <strong>Monument</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>Price</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(material, index) in quote.materials"
                    :key="'material' + index"
                  >
                    <b-col>
                      {{ material.name
                      }}<span>
                        - {{ material.size }} - {{ material.usage }}</span
                      >
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ material.price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.permit_fee > 0" class="permit-fee">
                  <b-row>
                    <b-col>
                      <strong>Permit Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ quote.permit_fee }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.inscriptions.length > 0" class="Inscription">
                  <b-row>
                    <b-col>
                      <strong>Inscription</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(inscription, index) in quote.inscriptions"
                    :key="'inscription' + index"
                  >
                    <b-col>
                      {{ inscription.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ inscription.price }} * {{ inscription.number }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.accessories.length > 0" class="Accessory">
                  <b-row>
                    <b-col>
                      <strong>Accessory</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(accessory, index) in quote.accessories"
                    :key="'accessory' + index"
                  >
                    <b-col>
                      {{ accessory.name }} - {{ accessory.size }} *
                      {{ accessory.quantity }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ accessory.total_price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.castings.length > 0" class="Casting">
                  <b-row>
                    <b-col>
                      <strong>Carving</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(casting, index) in quote.castings"
                    :key="'casting' + index"
                  >
                    <b-col>
                      {{ casting.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ casting.price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.installations.length > 0" class="Installation">
                  <b-row>
                    <b-col>
                      <strong>Installation</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(installation, index) in quote.installations"
                    :key="'installation' + index"
                  >
                    <b-col>
                      {{ installation.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ installation.price }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.foundations.length > 0" class="Foundation">
                  <b-row>
                    <b-col>
                      <strong>Foundation</strong>
                    </b-col>
                  </b-row>
                  <b-row
                    v-for="(foundation, index) in quote.foundations"
                    :key="'foundation' + index"
                  >
                    <b-col>
                      {{ foundation.name }}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{ foundation.price }}
                    </b-col>
                  </b-row>
                </div>
                <div
                  v-if="
                    quote.extra_fee != 0 &&
                      user.role == 'admin' &&
                      user.name != 'Jay'
                  "
                  class="extra-fee"
                >
                  <b-row>
                    <b-col>
                      <strong>Extra Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ quote.extra_fee }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      {{ quote.extra_fee_description }}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="quote.quote_discount > 0" class="discount">
                  <b-row>
                    <b-col>
                      <strong>Discount</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{ quote.quote_discount }}% off
                    </b-col>
                  </b-row>
                </div>
                <br />
                <div class="total-price">
                  <b-row>
                    <b-col>
                      <strong>Total Price</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>{{ quote.total_price }}</strong>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr />
        </div>
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-same-customer-alert')"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" @click="continueToCreate()">
            Continue
          </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  created() {
    var date_time = new Date();
    var dd = String(date_time.getDate()).padStart(2, "0");
    var mm = String(date_time.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = date_time.getFullYear();

    this.today = yyyy + "-" + mm + "-" + dd;

    firebase
      .firestore()
      .collection("lead_sources")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.lead_sources = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.lead_sources.length; i++) {
          this.lead_source_names.push(this.lead_sources[i].name);
        }
      });

    firebase
      .firestore()
      .collection("cemeteries")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.cemeteries = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.cemeteries.length; i++) {
          this.cemeteryNames.push(this.cemeteries[i].name);
        }
      });

    firebase
      .firestore()
      .collection("funeral_providers")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.funeral_providers = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.funeral_providers.length; i++) {
          this.funeral_provider_names.push(this.funeral_providers[i].name);
        }
      });

    firebase
      .firestore()
      .collection("job_styles")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.monument_styles = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.monument_styles.length; i++) {
          this.monument_style_names.push(this.monument_styles[i].name);
        }
      });

    firebase
      .firestore()
      .collection("monuments")
      .orderBy("english_name")
      .onSnapshot((collection) => {
        this.material_options = collection.docs.map((doc) => doc.data());
        this.material_options.forEach((e) => {
          this.material_name_options.push(e.english_name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "Arabic")
      .onSnapshot((collection) => {
        this.inscription_arabic_options = collection.docs.map((doc) =>
          doc.data()
        );
        this.inscription_arabic_options.forEach((e) => {
          this.inscription_arabic_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "Decoration")
      .onSnapshot((collection) => {
        this.inscription_decoration_options = collection.docs.map((doc) =>
          doc.data()
        );
        this.inscription_decoration_options.forEach((e) => {
          this.inscription_decoration_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "English")
      .onSnapshot((collection) => {
        this.inscription_english_options = collection.docs.map((doc) =>
          doc.data()
        );
        this.inscription_english_options.forEach((e) => {
          this.inscription_english_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "Chinese")
      .onSnapshot((collection) => {
        this.inscription_chinese_options = collection.docs.map((doc) =>
          doc.data()
        );
        this.inscription_chinese_options.forEach((e) => {
          this.inscription_chinese_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "Additional")
      .onSnapshot((collection) => {
        this.additional_inscription_options = collection.docs.map((doc) =>
          doc.data()
        );
        this.additional_inscription_options.forEach((e) => {
          this.additional_inscription_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("inscriptions")
      .orderBy("name")
      .where("type", "==", "Crypt Shutters")
      .onSnapshot((collection) => {
        this.crypt_shutters_options = collection.docs.map((doc) => doc.data());
        this.crypt_shutters_options.forEach((e) => {
          this.crypt_shutters_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("castings")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.casting_options = collection.docs.map((doc) => doc.data());
        this.casting_options.forEach((e) => {
          this.casting_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("installations")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.installation_options = collection.docs.map((doc) => doc.data());
        this.installation_options.forEach((e) => {
          this.installation_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("foundations")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.foundation_options = collection.docs.map((doc) => doc.data());
        this.foundation_options.forEach((e) => {
          this.foundation_name_options.push(e.name);
        });
      });

    firebase
      .firestore()
      .collection("accessories")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.accessory_options = collection.docs.map((doc) => doc.data());
        this.accessory_options.forEach((e) => {
          switch (e.type) {
            case "door":
              this.accessory_door_options.push(e);
              this.accessory_door_name_options.push(e.name);
              break;
            case "photo":
              this.accessory_photo_options.push(e);
              this.accessory_photo_name_options.push(e.name);
              break;
            default:
              this.accessory_others_options.push(e);
              this.accessory_others_name_options.push(e.name);
              break;
          }
        });
      });

    firebase
      .firestore()
      .collection("global_settings")
      .onSnapshot((collection) => {
        const settings = collection.docs.map((doc) => doc.data());
        if (settings.length > 0) {
          this.global_setting = settings[0];
          this.monument_discount = parseInt(
            this.global_setting.monument_discount
          );
          console.log(this.monument_discount);
        }
      });

      if (this.CRMOrder != null) {
        this.customer_name = this.CRMOrder.customerFirstName + ' ' + this.CRMOrder.customerLastName;
        this.customer_phone = this.CRMOrder.phone;
        this.customer_email = this.CRMOrder.email;
        // this.customer_cemetery = this.CRMOrder.cemetery;
        this.customer_funeral_provider = this.CRMOrder.funeralServiceProvider;
        this.customer_how_find = this.CRMOrder.leadSource;
        this.customer_comment = this.CRMOrder.description;
      }
  },
  computed: {},
  data() {
    return {
      today: "",
      monument_type: "",
      quotes_with_same_customer_name: [],
      lead_sources: [],
      lead_source_names: [],
      funeral_providers: [],
      funeral_provider_names: [],
      global_setting: null,
      monument_discount: 0,
      customer_comment: "",
      customer_name: "",
      customer_phone: "",
      customer_email: "",
      customer_cemetery: "",
      customer_section: "",
      customer_funeral_provider: "",
      customer_row: "",
      customer_grave_number: "",
      customer_how_find: "",
      cemeteryNames: [],
      created_by_name: "",
      create_date: "",
      monument_style: "",
      monument_style_names: [],
      permit_fee: 0,
      materials: [],
      material_options: [],
      material_name_options: [],
      material_changed: false,
      inscriptions: [],
      inscription_options: [],
      inscription_name_options: [],

      inscription_arabic_options: [],
      inscription_arabic_name_options: [],

      inscription_decoration_options: [],
      inscription_decoration_name_options: [],

      inscription_english_options: [],
      inscription_english_name_options: [],

      inscription_chinese_options: [],
      inscription_chinese_name_options: [],

      additional_inscription_options: [],
      additional_inscription_name_options: [],

      crypt_shutters_options: [],
      crypt_shutters_name_options: [],

      castings: [],
      casting_options: [],
      casting_name_options: [],
      installations: [],
      installation_options: [],
      installation_name_options: [],
      accessories: [],
      accessory_options: [],
      accessory_doors: [],
      accessory_door_options: [],
      accessory_door_name_options: [],
      accessory_photos: [],
      accessory_photo_options: [],
      accessory_photo_name_options: [],
      accessory_others: [],
      accessory_others_options: [],
      accessory_others_name_options: [],
      foundations: [],
      foundation_options: [],
      foundation_name_options: [],
      extra_fee: 0,
      extra_fee_description: "",
      quote_discount: 0,
      total_price: 0,
      no_of_items: 0,
      quote_created: false,
      newQuote: Object,
      created_successfully: false,
      isProcessing: false,
    };
  },
  props: {
    new_quote_type: String,
    user: Object,
    from: String,
    CRMOrder: Object,
  },
  watch: {},
  methods: {
    back() {
      this.$emit("backTo", this.from);
    },
    add_material() {
      this.materials.push({
        name: "",
        size: "",
        usage: "",
        price: 0,
        prices: [],
        sizes: [],
        total_price: 0,
      });
    },
    add_inscription(type) {
      this.inscriptions.push({
        type: type,
        name: "",
        number: 1,
        price: 0,
      });
    },
    add_casting() {
      this.castings.push({
        name: "",
        price: 0,
      });
    },
    add_installation() {
      this.installations.push({
        name: "",
        price: 0,
      });
    },
    add_foundation() {
      this.foundations.push({
        name: "",
        price: 0,
      });
    },
    add_door() {
      this.accessory_doors.push({
        name: "",
        size: "",
        price: "",
        sizes: [],
        prices: [],
        quantity: 1,
        total_price: 0,
      });
    },
    add_photo() {
      this.accessory_photos.push({
        name: "",
        size: "",
        price: "",
        prices: [],
        sizes: [],
        quantity: 1,
        total_price: 0,
      });
    },
    add_others() {
      this.accessory_others.push({
        name: "",
        size: "",
        price: "",
        prices: [],
        sizes: [],
        quantity: 1,
        total_price: 0,
      });
    },
    materials_changed(oldName) {
      var index = 0;
      this.materials.forEach((e) => {
        if (e.name.length > 0 && e.name == oldName) {
          index = this.material_name_options.indexOf(e.name);

          e.size = "";
          e.sizes = [];
          (e.prices = []),
            this.material_options[index].priceAndSize.forEach((p) => {
              e.sizes.push(p.size);
              e.prices.push(p.price);
            });
        }
      });
    },
    material_size_change(index) {
      const m = this.materials[index];
      if (m.size != null) {
        m.price = m.prices[m.sizes.indexOf(m.size)];
      }
    },
    inscriptions_change(name) {
      this.inscriptions.forEach((e) => {
        if (e.name == name) {
          if (e.type == "arabic") {
            e.price = this.inscription_arabic_options[
              this.inscription_arabic_name_options.indexOf(e.name)
            ].price;
          }
          if (e.type == "decoration") {
            e.price = this.inscription_decoration_options[
              this.inscription_decoration_name_options.indexOf(e.name)
            ].price;
          }
          if (e.type == "english") {
            e.price = this.inscription_english_options[
              this.inscription_english_name_options.indexOf(e.name)
            ].price;
          }
          if (e.type == "chinese") {
            e.price = this.inscription_chinese_options[
              this.inscription_chinese_name_options.indexOf(e.name)
            ].price;
          }
          if (e.type == "Additional") {
            e.price = this.additional_inscription_options[
              this.additional_inscription_name_options.indexOf(e.name)
            ].price;
          }
          if (e.type == "Crypt Shutters") {
            e.price = this.crypt_shutters_options[
              this.crypt_shutters_name_options.indexOf(e.name)
            ].price;
          }
          //alert(e.price);
        }
      });
    },
    accessory_doors_changed(name) {
      var index = 0;
      this.accessory_doors.forEach((e) => {
        if (e.name.length > 0 && e.name == name) {
          index = this.accessory_door_name_options.indexOf(e.name);

          e.size = "";
          e.prices = [];
          e.sizes = [];
          this.accessory_door_options[index].specAndPrice.forEach((p) => {
            e.sizes.push(p.spec);
            e.prices.push(p.price);
          });
        }
      });
    },
    accessory_doors_size_changed(index) {
      const d = this.accessory_doors[index];
      console.log(d.size);
      if (d.size != null) {
        d.price = d.prices[d.sizes.indexOf(d.size)];
        //alert(d.price);
      }
    },
    accessory_photos_changed(name) {
      var index = 0;
      this.accessory_photos.forEach((e) => {
        if (e.name.length > 0 && e.name == name) {
          index = this.accessory_photo_name_options.indexOf(e.name);

          e.size = "";
          e.prices = [];
          e.sizes = [];
          this.accessory_photo_options[index].specAndPrice.forEach((p) => {
            e.sizes.push(p.spec);
            e.prices.push(p.price);
          });
        }
      });
    },
    accessory_photos_size_changed(index) {
      const p = this.accessory_photos[index];
      if (p.size != null) {
        p.price = p.prices[p.sizes.indexOf(p.size)];
        //alert(p.price);
      }
    },
    accessory_others_changed(name) {
      var index = 0;
      this.accessory_others.forEach((e) => {
        if (e.name.length > 0 && e.name == name) {
          index = this.accessory_others_name_options.indexOf(e.name);

          e.size = "";
          e.sizes = [];
          e.prices = [];
          this.accessory_others_options[index].specAndPrice.forEach((p) => {
            e.sizes.push(p.spec);
            e.prices.push(p.price);
          });
        }
      });
    },
    accessory_others_size_changed(index) {
      const o = this.accessory_others[index];
      if (o.size != null) {
        o.price = o.prices[o.sizes.indexOf(o.size)];
        //alert(o.price);
      }
    },
    castings_change(name) {
      this.castings.forEach((e) => {
        if (e.name == name) {
          e.price = this.casting_options[
            this.casting_name_options.indexOf(e.name)
          ].price;
          //alert(e.price);
        }
      });
    },
    installations_change(name) {
      this.installations.forEach((e) => {
        if (e.name == name) {
          e.price = this.installation_options[
            this.installation_name_options.indexOf(e.name)
          ].price;
          e.type = this.installation_options[
            this.installation_name_options.indexOf(e.name)
          ].type;
          //alert(e.price);
        }
      });
    },
    foundations_change(name) {
      this.foundations.forEach((e) => {
        if (e.name == name) {
          e.price = this.foundation_options[
            this.foundation_name_options.indexOf(e.name)
          ].price;
          //alert(e.price);
        }
      });
    },
    remove_material(index) {
      this.materials.splice(index, 1);
    },
    remove_inscription(index) {
      this.inscriptions.splice(index, 1);
    },
    remove_foundation(index) {
      this.foundations.splice(index, 1);
    },
    remove_casting(index) {
      this.castings.splice(index, 1);
    },
    remove_installation(index) {
      this.installations.splice(index, 1);
    },
    remove_door(index) {
      this.accessory_doors.splice(index, 1);
    },
    remove_photo(index) {
      this.accessory_photos.splice(index, 1);
    },
    remove_others(index) {
      this.accessory_others.splice(index, 1);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    create_quote() {
      firebase
        .firestore()
        .collection("quotes")
        .where("customer_name", "==", this.customer_name)
        .get()
        .then((collection) => {
          this.quotes_with_same_customer_name = collection.docs.map((doc) =>
            doc.data()
          );
          console.log("gg");

          if (this.quotes_with_same_customer_name.length > 0) {
            this.showModal("modal-same-customer-alert");
          } else {
            this.calculate_price();

            if (this.no_of_items < 3 && this.new_quote_type == "monument") {
              alert("A monument quote must include at least 3 items!");
              return;
            } else if (
              this.no_of_items < 2 &&
              this.new_quote_type == "inscription"
            ) {
              alert("A inscription quote must include at least 2 items!");
              return;
            }

            this.created_by_name = this.user.name;
            this.create_date = this.today;

            this.accessories = [];
            this.accessory_doors.forEach((e) => {
              this.accessories.push(e);
            });
            this.accessory_photos.forEach((e) => {
              this.accessories.push(e);
            });
            this.accessory_others.forEach((e) => {
              this.accessories.push(e);
            });

            this.showModal("modal-create-quote");
          }
        });
    },
    create_quote_task() {
      this.hideModal("modal-create-quote");

      if (!this.quote_created) {
        var date_time = new Date();
        var dd = String(date_time.getDate()).padStart(2, "0");
        var mm = String(date_time.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = date_time.getFullYear();

        const today = yyyy + "-" + mm + "-" + dd;

        const new_quote_ref = firebase
          .firestore()
          .collection("quotes")
          .doc();

        this.newQuote = {
          monument_type: this.monument_type,
          id: new_quote_ref.id,
          customer_comment: this.customer_comment,
          customer_name: this.customer_name,
          customer_phone: this.customer_phone,
          customer_email: this.customer_email,
          customer_cemetery: this.customer_cemetery,
          customer_section: this.customer_section,
          customer_funeral_provider: this.customer_funeral_provider,
          customer_row: this.customer_row,
          customer_grave_number: this.customer_grave_number,
          customer_how_find: this.customer_how_find,
          monument_style: this.monument_style,
          permit_fee: this.permit_fee,
          materials: this.materials,
          inscriptions: this.inscriptions,
          castings: this.castings,
          installations: this.installations,
          accessories: this.accessories,
          accessory_doors: this.accessory_doors,
          accessory_photos: this.accessory_photos,
          accessory_others: this.accessory_others,
          foundations: this.foundations,
          extra_fee: this.extra_fee,
          extra_fee_description: this.extra_fee_description,
          quote_discount: this.quote_discount,
          create_date: today,
          create_year_month: today.substring(0, 7),
          create_day: parseInt(today.substring(8, 10)),
          total_price: this.total_price,
          no_of_items: this.no_of_items,
          created_by: this.user,
          created_by_name: this.user.name,
          failed_reason: "",
          status: "pending",
          type: this.new_quote_type,
          orderId: "",
        };

        if (this.CRMOrder != null) {
          this.newQuote.orderId = this.CRMOrder.id;
        }

        new_quote_ref.set(this.newQuote).then(() => {
          this.created_successfully = true;
          this.quote_created = true;
        });

        const new_daily_report_ref = firebase
          .firestore()
          .collection("daily_reports")
          .doc();

        var new_daily_report = {
          branch: "",
          cemetery_name: this.customer_cemetery,
          created_by: this.user,
          created_by_name: this.user.name,
          created_date: this.today,
          year_month: this.today.substring(0, 7),
          day: parseInt(this.today.substring(8,10)),
          date_timestamp: new Date(this.today),
          follower_object: this.user,
          follower: this.user.name,
          customer_enquiry: this.customer_comment,
          customer_name: this.customer_name,
          customer_phone: this.customer_phone,
          date: this.today,
          funeral_provider: this.customer_funeral_provider,
          how_did_you_find_us: this.customer_how_find,
          id: new_daily_report_ref.id,
          is_sales_contract_signed: "",
          status: "pending",
          failed_reason: "",
        };

        new_daily_report_ref.set(new_daily_report);
      }
    },
    //quote_discount means Material Discount
    calculate_price() {
      var contain_accessory = false;
      this.total_price = 0.0;
      this.no_of_items = 0;

      if (this.materials.length > 0) {
        this.materials.forEach((m) => {
          this.no_of_items += 1;
          console.log(
            m.price +
              " " +
              m.usage +
              " " +
              this.monument_discount +
              "% " +
              this.quote_discount
          );
          m.total_price = Math.round((
            parseInt(m.price) *
            parseFloat(m.usage) *
            ((this.monument_discount * 1.0) / 100) *
            (1 - (this.quote_discount * 1.0) / 100)
          ).toFixed(2));
          // console.log(m.price);
          if (
            m.name.length == 0 ||
            m.price.length == 0 ||
            m.usage.length == 0
          ) {
            alert("The size, name and usage of materials must be determined!!");
            return;
          } else {
            this.total_price += parseFloat(m.total_price);
          }
        });
      }

      if (this.permit_fee != null && this.permit_fee > 0) {
        this.no_of_items += 1;
        this.total_price += parseFloat(this.permit_fee);
      }

      if (this.inscriptions.length > 0) {
        this.inscriptions.forEach((i) => {
          this.no_of_items += 1;
          if (i.name.length == 0 || i.number == 0) {
            alert("The number and name of inscriptions must be determined!!");
            return;
          } else {
            if (
              i.name == "[Per Letter]Under 40 letters(& included 40 letters)"
            ) {
              this.total_price += 200;
            }
            this.total_price += parseFloat(i.price) * parseFloat(i.number);
          }
        });
        // console.log(this.total_price);
      }

      if (this.accessory_doors.length > 0) {
        if (!contain_accessory) {
          contain_accessory = true;
        }
        this.accessory_doors.forEach((d) => {
          this.no_of_items += 1;
          if (d.name.length == 0 || d.size.length == 0) {
            alert("The size and name of doors must be determined!!");
            return false;
          } else {
            d.total_price = parseFloat(d.price) * parseInt(d.quantity);
            this.total_price += d.total_price;
          }
        });
        // console.log(this.total_price);
      }

      if (this.accessory_photos.length > 0) {
        if (!contain_accessory) {
          contain_accessory = true;
        }
        this.accessory_photos.forEach((p) => {
          this.no_of_items += 1;
          if (p.name.length == 0 || p.size.length == 0) {
            alert("The size and name of photos must be determined!!");
            return;
          } else {
            p.total_price = parseFloat(p.price) * parseInt(p.quantity);
            this.total_price += p.total_price;
          }
        });
        // console.log(this.total_price);
      }

      if (this.accessory_others.length > 0) {
        if (!contain_accessory) {
          contain_accessory = true;
        }
        this.accessory_others.forEach((o) => {
          this.no_of_items += 1;
          if (o.name.length == 0 || o.size.length == 0) {
            alert(
              "The size and name of other accessories must be determined!!"
            );
            return;
          } else {
            o.total_price = parseFloat(o.price) * parseInt(o.quantity);
            this.total_price += o.total_price;
          }
        });
        // console.log(this.total_price);
      }

      if (this.castings.length > 0) {
        this.castings.forEach((c) => {
          this.no_of_items += 1;
          if (c.name.length == 0) {
            alert("The name of casting must be determined");
            return;
          } else {
            this.total_price += parseFloat(c.price);
          }
        });
        // console.log(this.total_price);
      }

      // console.log(this.total_price);

      if (this.installations.length > 0) {
        for (var i = 0; i < this.installations.length; i++) {
          this.no_of_items += 1;
          if (this.installations[i].name.length == 0) {
            alert("The name of installation must be determined");
            return;
          } else if (this.installations[i].name == 'Remove Existing Monument - Major(Whole Monument)') {
            for (var c = 0; c < this.installations.length; c++) {
              console.log('loop' + c + this.installations[c].name + this.installations[c].type);
              if (this.installations[c].name.length == 0) {
                alert("The name of installation must be determined");
                return;
              } else if (this.installations[c].name == 'Remove Existing Monument - Major(Whole Monument)') {
                continue;
              } else if (this.installations[c].type == 'Double' || this.installations[c].type == 'Single' || this.installations[c].type == 'Lawn'){
                this.total_price += parseFloat(this.installations[c].price);
                console.log(this.total_price);
              }
            }
          } else {
            this.total_price += parseFloat(this.installations[i].price);
          }
        }
      }

      if (this.foundations.length > 0) {
        this.foundations.forEach((f) => {
          this.no_of_items += 1;
          if (f.name.length == 0) {
            alert("The name of casting must be determined");
            return;
          } else {
            this.total_price += parseFloat(f.price);
          }
        });
        // console.log(this.total_price);
      }

      if (this.extra_fee != null && this.extra_fee != 0) {
        this.total_price += parseFloat(this.extra_fee);
      }
      this.total_price = this.total_price.toFixed(2);
    },
    export_quote() {
      this.$emit("viewQuote", { quote: this.newQuote, from: "Quotes" });
    },
    continueToCreate() {
      this.hideModal("modal-same-customer-alert");
      this.calculate_price();

      if (this.no_of_items < 3 && this.new_quote_type == "monument") {
        alert("A monument quote must include at least 3 items!");
        return;
      } else if (this.no_of_items < 2 && this.new_quote_type == "inscription") {
        alert("A inscription quote must include at least 2 items!");
        return;
      }

      this.created_by_name = this.user.name;
      this.create_date = this.today;

      this.accessories = [];
      this.accessory_doors.forEach((e) => {
        this.accessories.push(e);
      });
      this.accessory_photos.forEach((e) => {
        this.accessories.push(e);
      });
      this.accessory_others.forEach((e) => {
        this.accessories.push(e);
      });

      this.showModal("modal-create-quote");
    },
  },
};
</script>

<style scoped>
p {
  font-weight: bold;
  font-size: 90%;
  margin: 0px;
  padding: 0px;
}
</style>
